<ng-container *ngIf="_dispute.modalTypes.submittion == modalType">
    <div class="modal-dialog  m-0 p-3">

        <!-- <img src="assets/images/icons/cross-icon.svg" alt=""
            class="hw-32 border rounded-circle p-1 cursor position-absolute top-16 end-16 z-3" (click)="modalHide()"> -->

        <div class="modal-body py-4">
            <div class="text-center">
                <img src="assets/images/icons/tick-star-icon.png" alt="" class="mb-4">
                <h4 class="fs-20 fw-800 mb-4" style="font-size: 20px;font-weight: 700;">
                    Documents Submitted Successfully!
                </h4>
                <p class="fs-16 fw-500 mb-4 " style="font-size: 16px;font-weight: 400;">
                    Thank you for your submission! We appreciate <br> your effort in keeping your payments process <br>smooth and hassle-free.
                </p>
                <p style="color: #EDFDF3; padding: 10px 25px; color: rgba(52, 122, 42, 1);font-weight: 600;font-size: 16px;" class="mb-1 fw-700 fs-16" ><span><img
                    src="assets/images/icons/tick-icon.png" class="me-2 fw-700" style="font-weight: 600;"></span> {{extra_data.doc_count}} Document Uploaded</p>
        <p style="color: #EDFDF3; padding: 10px 25px; color: rgb(235, 25, 10);font-weight: 600;font-size: 16px;" class="fw-700 fs-16"><span><img
                    src="assets/images/icons/pending-icon.png" class="me-2 fw-700" style="font-weight: 600;"></span> {{pending_doc}} Document Pending</p>
            </div>

        </div>
        <div class="modal-footer border-0">
            <button class="btn btn-secondary mb-3 w-100 fw-700" [routerLink]="'/app/dashboard'"
                (click)="modalHide()">Close</button>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="_dispute.modalTypes.addMoreDocuments == modalType || _dispute.modalTypes.upload_doc == modalType">
    <div class="modal-dialog modal-md  modal-dialog-centered d-block m-0 p-0 px-3">
        <div class="modal-header align-items-center justify-content-between border-0 pb-0">
            <h4 class="fs-18 fw-700 m-0">
                {{_dispute.modalTypes.addMoreDocuments == modalType ? 'Add More Document' : 'Upload Document' }} 
            </h4>
            <img src="assets/images/icons/cross-icon.svg" alt="" class="hw-30 cursor border rounded-circle p-1"
                (click)="modalHide()">
        </div>
        <div class="modal-body">
            <div class="mb-4" *ngIf="extra_data.showInput">
                <label for="" class="w-100 fs-14 fw-600">File Name</label>
                <input type="text" class="input_field w-100" [(ngModel)]="new_doc_name" placeholder="File Name">
            </div>
           
            
            <div class="w-100 p-4 text-center mb-4 cursor" style="border: 1px dashed rgba(228, 228, 228, 1);" 
            (click)="!isUploading && !uploadedFile ? fileInput.click() : null">
           <img src="assets/images/menu-icons/upload-icon.png" alt="" class="mb-3">
           <p class="fs-14 fw-600 text-primary m-0 mb-1">Click to upload file</p>
           <p class="fs-12 fw-400 m-0">Max file size : 10MB, Supported files: pdf, jpeg, png</p>
           <input #fileInput id="fileInput" type="file" (change)="onFileSelected($event)" 
                  accept=".pdf, .jpeg, .png" style="display: none;">
       </div>
       
       <!-- <div *ngIf="uploadError" class="alert alert-danger">
         error
       </div> -->
       
       <div class="d-flex align-items-center" *ngIf="isUploading || uploadedFile">
        <img src="assets/images/icons/image-icon.png" alt="">
          <div class="flex-fill">
            <p *ngIf="uploadedFile && uploadedFile.name && uploadProgress == 100" class="m-0 fs-12 fw-500 pb-1 pe-2">
                {{ uploadedFile.name}}
                <span class="fw-400">
                    {{
                    uploadedFile.size >= 1024 * 1024
                    ? (uploadedFile.size / (1024 * 1024)).toFixed(2) + ' MB'
                    : uploadedFile.size >= 1024
                    ? (uploadedFile.size / 1024).toFixed(2) + ' KB'
                    : uploadedFile.size + ' Bytes'
                    }}
                </span>
            </p>
            <div class="progress d-flex " style="height: 4px;">
                <div class="progress-bar progress-bar-striped progress-bar-animated" 
                     role="progressbar" [style.width.%]="uploadProgress" 
                     [attr.aria-valuenow]="uploadProgress" [attr.aria-valuemin]="0" 
                     [attr.aria-valuemax]="100">
                </div>
            </div>
          </div>
           <span class="d-flex justify-content-center align-items-center hw-24 mx-3 fs-12 fw-500" >
               {{uploadProgress}}%
           </span>
           <img src="assets/images/icons/red-cross-icon.svg" alt="" class="hw-24 cursor p-1" *ngIf="!isUploading && uploadedFile" (click)="removeFile()">
       </div>
        </div>
        <div class="modal-footer border-0 pt-0">
            <button class="btn btn-secondary" [disabled]="!uploadedFile || isUploading" 
                    (click)="uploadFile()">Upload File</button>
        </div>
    </div>
</ng-container>